import { createContext, useContext } from 'react';
import { type QuizClientType } from './client';

const QuizClientContext = createContext<QuizClientType | null>(null);

export const useQuizClient = (): QuizClientType => {
    const client = useContext(QuizClientContext);

    if (!client) {
        throw new Error('useQuizClient must be used within a QuizClientProvider.');
    }

    return client;
};

interface ProviderProps {
    client: QuizClientType;
    children?: React.ReactNode;
}

export const QuizClientProvider = (props: ProviderProps) => {
    return (
        <QuizClientContext.Provider value={props.client}>
            {props.children}
        </QuizClientContext.Provider>
    );
};
